import type { ACHIEVEMENT_TYPES } from './achievements';

export type QuestAchievementType =
  | ACHIEVEMENT_TYPES.CAMPUS_EXPLORER
  | ACHIEVEMENT_TYPES.GAIN_CONFIDENCE
  | ACHIEVEMENT_TYPES.GOOD_HABITS
  | ACHIEVEMENT_TYPES.SNAP_FINGERS;

export enum QUEST_STATUSES {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  LOCKED = 'LOCKED',
}
